import { MutableRefObject, useCallback } from 'react';
import { RsiData, RsiRowOnErrorCallback, RsiRowValidator } from '../../../Types';
import { useImportersIntl } from '../../../translations/useImportersIntl';
import { ENGAGEMENT_ID_URN } from './useValidateTableAgainstEngagementOpenChangeSet';

export function useValidateRowAgainstEngagementOpenChangeSet(
  openChangeSetIdsRef: MutableRefObject<Set<string>>
): RsiRowValidator {
  const { hasPendingChanges } = useImportersIntl();

  return useCallback(
    (row: RsiData, addError: RsiRowOnErrorCallback) => {
      const engagementId = row[ENGAGEMENT_ID_URN];
      if (typeof engagementId === 'string' && openChangeSetIdsRef.current.has(engagementId)) {
        addError(ENGAGEMENT_ID_URN, { level: 'warning', message: hasPendingChanges });
      }
    },
    [hasPendingChanges, openChangeSetIdsRef]
  );
}
